module.exports = __webpack_public_path__ + "img/full5-min.e4c66d2f.png";